import React from 'react';

const AdContext = React.createContext({
  adKeys: [],
  addAdKey: () => { },
  removeAdKey: () => { },
});

export const useAdContext = () => {
  const context = React.useContext(AdContext);
  if (context === undefined) {
    throw new Error('useAdContext must be used within an AdProvider. Make sure your component is wrapped in AdProvider.');
  }
  return context;
};

export const AdProvider = ({ children }) => {
  const [adKeys, setAdKeys] = React.useState([]);

  const addAdKey = React.useCallback((adKey) => {
    setAdKeys((prevKeys) => [...prevKeys, adKey]);
  }, [setAdKeys]);

  const removeAdKey = React.useCallback((adKey) => {
    setAdKeys((prevKeys) => prevKeys.filter((key) => key !== adKey));
  }, [setAdKeys]);

  const value = React.useMemo(
    () => ({
      adKeys,
      addAdKey,
      removeAdKey,
    }),
    [adKeys, addAdKey, removeAdKey]
  );

  return <AdContext.Provider value={value}>{children}</AdContext.Provider>;
};
